@if (setLoader) {
  <div class="loader-container">
    <div class="loader">
      <div class="circle"></div>
      <div class="title-small-bold">Loading</div>
    </div>
  </div>
}
